module.exports = __webpack_public_path__ + "media/2x/L-3ca6d587.png";